module.exports = "/_next/static/images/bgFeature-a0069213d7ea5a3237924cd68cb4d586.png.webp";